const refinementCrumbsTransform = (refinementCrumbsGql = {}) => {
  if (!refinementCrumbsGql) {
    return null; // current state
  }

  const {
    displayName, // "product.category",
    dimensionName, // "product.category",
    label,
    multiSelect,
    properties: {
      navigationState, // "/c/men-shorts/_/N-7u7",
      nValue, // "N-7u7"
    } = {},
    ancestors = [],
  } = refinementCrumbsGql;

  return {
    count: null,
    properties: {
      "n-value": nValue,
      "navigation-state": navigationState,
    },
    label,
    "remove-action": null, // ??
    "display-name": displayName,
    "multi-select": multiSelect,
    "dimension-name": dimensionName,
    ancestors: ancestors?.map(({ properties, label, navigationState }) => ({
      properties,
      label,
      "navigation-state": navigationState,
      "site-root-path": null, // ??
      "content-path": null, // ??
    })),
  };
};

export default refinementCrumbsTransform;
